import { useContext, useEffect ,useState} from "react"
import CartContext from "../../store/cart-context"
import CartIcon from "../Cart/CartIcon"
import classes from "./HeaderCartButton.module.css"

const HeaderCartButton = props =>{
    const [btnishighlighted,setbtnishighlighted] = useState(false)
    const cartCtx = useContext(CartContext)
    const numberOfCartItems = cartCtx.items.reduce((curNumber,item)=>{
        return curNumber+item.amount;
    },0);

    const {items} = cartCtx
    const buttonClasses = `${classes.button} ${btnishighlighted ?classes.bump:""}`
    useEffect(()=>{
        if (items.length === 0){
            return;
        }
        setbtnishighlighted(true)
        const timer = setTimeout(()=>{setbtnishighlighted(false)},300)
        return ()=>{
            clearTimeout(timer)
        }
    },[items])
    return (
        <button className={buttonClasses} onClick={props.onClick}>
            <span  className={classes.icon}>
                <CartIcon/>
            </span>
            <span>Your Cart</span>
            <span className={classes.badge}>{numberOfCartItems}</span>
        </button>
    )
}
export default HeaderCartButton